import { render, staticRenderFns } from "./typhoonList.vue?vue&type=template&id=45c193fa&scoped=true&"
import script from "./typhoonList.vue?vue&type=script&lang=js&"
export * from "./typhoonList.vue?vue&type=script&lang=js&"
import style0 from "./typhoonList.vue?vue&type=style&index=0&id=45c193fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c193fa",
  null
  
)

export default component.exports